export { default } from './elementTypeAcceptingRef';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/elementTypeAcceptingRef/index.js
// module id = 112
// module chunks = 22